const Show = ({children, condition}) => (
    condition ? (
        children
    ) : null
);

export default Show;
export {Show};
